import { type AxiosInstance, type AxiosRequestHeaders } from 'axios'

/**
 * The de-facto standard for configuring an Axios client.
 *
 * WARNING: Retries should NOT be directly added to clients, but rather clients should be consumed
 * throught React Query, which handles caching and retries.
 */
export const configureClient = <T extends AxiosInstance>(
  client: T,
  options: Pick<T['defaults'], 'baseURL'> & {
    /**
     * Provides a getter for the authorization token, if needed.
     * Otherwise no authorization header will be automatically set by the client.
     */
    getToken?: () => Promise<string | null | undefined>
  }
) => {
  // set API url
  if (options.baseURL) {
    client.defaults.baseURL = options.baseURL
  }

  // add authorization header
  if (typeof options.getToken !== 'undefined') {
    client.interceptors.request.use(async (request) => {
      const token = await options.getToken!()

      if (!request.headers) {
        request.headers = {} as AxiosRequestHeaders
      }

      if (token) {
        request.headers['authorization'] = `Bearer ${token}`
      }

      return request
    })
  }

  return client
}
